// libraries.
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// domains.
import { setNid } from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';
import { orchestratorPricingCommittee } from '@domains/orchestrator-pricing-committee/store/services/getOrchestratorPricingCommittee';

export const SearchOrchestratorPricingCommittee = () => {
  const dispatch = useDispatch();

  const { currentOrchestrator, rawNid } = useCurrentOrchestrator();

  const { isError, isFetching, isSuccess, data } = currentOrchestrator;

  useEffect(() => {
    if (isError) {
      toast.error('Error cargando orquestador', {
        toastId: 'error-orchestrator',
        position: 'top-center',
      });
      dispatch(orchestratorPricingCommittee.util.resetApiState());
      dispatch(setNid(''));
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess && !data) {
      dispatch(orchestratorPricingCommittee.util.resetApiState());
    }
  }, [isSuccess, data, dispatch]);

  useEffect(() => {

    if (isFetching) {
      toast.loading('Cargando orquestador...', {
        toastId: 'loading-orchestrator',
        position: 'bottom-right',
      });
    } else {
      toast.dismiss('loading-orchestrator');
    }
  }, [isFetching]);

  useEffect(() => {
    return () => {
      toast.dismiss('loading-orchestrator');
    };
  }, []);

  return (
    <div style={{ maxWidth: '400px' }}>
      <Form>
        <Form.Group controlId="nidSearch">
          <Form.Control
            style={{ fontSize: '14px' }}
            type="text"
            placeholder="Buscar por Nid..."
            value={rawNid}
            onChange={e => dispatch(setNid(e.target.value.trim()))}
          />
        </Form.Group>
      </Form>
    </div>
  );
};
